export * from './AssessmentDetail';
